// Threads the active UI language into the shared FeedbackProvider (toast +
// confirm dialog). Rendered once in main.jsx, inside LanguageProvider so
// useLanguage() is available, wrapping the whole app so useToast() /
// useConfirm() work from any screen.
import { FeedbackProvider } from 'shared/components/Feedback/index.js';
import { useLanguage } from '../context/LanguageContext.jsx';

export default function AppFeedback({ children }) {
  const { lang } = useLanguage();
  return <FeedbackProvider lang={lang}>{children}</FeedbackProvider>;
}
